import { useEffect, useState } from "react";
import { ActionButton } from '../../components/Forms/ActionButton';
import ChallengeWiseSubmissionTable from "./components/ChallengeWiseSubmissionTable";
import AiReviewSettings from "./components/AiReviewSettings";
import { challengeSubmissionList, getCategoriesForFilters, getChallengesForFilters, getUsersForFilters } from "../../api/challenge";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ChallengeSubmissions = () => {

    // const [selectedTab, setSelectedTab] = useState('challenge-information'); // [ submission-information, products/services ]
    const [data, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filteredUsers, setFilteredUsers] = useState([]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Filters
    const [searchTerm, setSearchTerm] = useState("");
    const [categoryStatus, setCategoryStatus] = useState("");
    const [challengeName, setChallengeName] = useState("");
    const [user, setUser] = useState("");
    const [checkingStatus, setCheckingStatus] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [complexity, setComplexity] = useState("");
    const [inclusive, setInclusive] = useState("");

    const [userData, setUserData] = useState([]);
    const [challengeData, setChallengeData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);

    const loadData = async (page = currentPage, pageSize = itemsPerPage) => {
        const filters = {};
        if (user) filters.userId = user;
        if (challengeName) filters.challengeId = challengeName;
        if (checkingStatus) filters.reviewStatus = checkingStatus;
        if (fromDate) filters.fromDate = fromDate;
        if (toDate) filters.toDate = toDate;

        const pagination = await challengeSubmissionList(
            setFilteredUsers,
            toast,
            setIsLoading,
            filters,
            page,
            pageSize
        );

        if (pagination) {
            setCurrentPage(pagination.currentPage);
            setTotalPages(pagination.totalPages);
            setTotalItems(pagination.totalItems);
        }
    };

    const applyFilters = () => {
        setCurrentPage(1); // Reset to page 1 when applying filters
        loadData(1);
    }

    const handleSearch = (e) => {
        e.preventDefault();
        applyFilters();
    }

    const resetFilters = () => {
        setSearchTerm("");
        setCategoryStatus("");
        setChallengeName("");
        setUser("");
        setCheckingStatus("");
        setFromDate("");
        setToDate("");
        setComplexity("");
        setInclusive("");
        setCurrentPage(1);
        loadData(1);
    }

    useEffect(() => {
        loadData(1);
        getUsersForFilters(setUserData);
        getChallengesForFilters(setChallengeData);
        getCategoriesForFilters(setCategoryData);
    }, []);

    return (
        <div className="flex flex-col pb-14 max-md:pt-24">
            <div className="flex flex-col max-md:pt-24">
                {/* AI review: auto approve / reject settings (admin controlled) */}
                <AiReviewSettings />
                {/* Filters */}
                <form className="flex flex-col px-4 pt-5 pb-5 bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:pt-24" onSubmit={handleSearch}>
                    <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 w-5 aspect-square"
                        />
                        <span className="self-stretch">Filters</span>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 aspect-square w-[18px]"
                        />
                    </div>
                    <div className="flex flex-wrap flex-auto gap-2.5 self-start p-2 tracking-widest whitespace-nowrap rounded-md border border-solid bg-zinc-300 bg-opacity-0 border-navBtn text-zinc-400 w-full mt-3">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/a945212e3480badae8ec120c2470ee1a05ad62400839168e9007e1ac6f6d6f87?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 self-start w-5 aspect-square"
                        />
                        <input
                            type="search"
                            placeholder="Search by challenge name or username..."
                            aria-label="Search"
                            className="flex-auto max-md:max-w-full bg-transparent border-none outline-none text-base text-gray-900 placeholder-gray-500"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="flex gap-3 items-center mt-4 text-base w-full">
                        {/* Category */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="categoryStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Category
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="categoryStatus"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={categoryStatus}
                                    onChange={(e) => setCategoryStatus(e.target.value)}
                                >
                                    <option value="">All</option>
                                    {
                                        categoryData && categoryData.map(category => (
                                            <option key={category._id} value={category._id}>{category.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        {/* Challenge Name */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="challengeName" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Challenge Name
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="challengeName"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={challengeName}
                                    onChange={(e) => setChallengeName(e.target.value)}
                                >
                                    <option value="">All</option>
                                    {
                                        challengeData && challengeData.map(challenge => (
                                            <option key={challenge._id} value={challenge._id}>{challenge.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        {/* User */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="user" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                User
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="user"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={user}
                                    onChange={(e) => setUser(e.target.value)}
                                >
                                    <option value="">All</option>
                                    {
                                        userData && userData.map(user => (
                                            <option key={user._id} value={user._id}>{user.username}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        {/* Checking Status */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Checking Status
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="checkingStatus"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={checkingStatus}
                                    onChange={(e) => setCheckingStatus(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="submitted">Verified</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-3 items-center mt-4 text-base w-full">
                        {/* From Submission Date */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                From Submission Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    id="fromDate"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                        </div>
                        {/* To Submission Date */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                To Submission Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    id="toDate"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                        </div>
                        {/* Complexity */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="complexity" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Complexity
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="complexity"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={complexity}
                                    onChange={(e) => setComplexity(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="easy">Easy</option>
                                    <option value="moderate">Moderate</option>
                                    <option value="hard">Hard</option>
                                </select>
                            </div>
                        </div>
                        {/* Inclusive */}
                        <div className="flex-col basis-1/4">
                            <label htmlFor="inclusive" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Inclusive
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    id="inclusive"
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base text-gray-900"
                                    value={inclusive}
                                    onChange={(e) => setInclusive(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-3 items-center justify-end mt-6 text-base">
                        <ActionButton
                            variant={'reset'}
                            text={'Reset'}
                            onClick={resetFilters}
                        />
                        <ActionButton
                            variant={'submit'}
                            text={'Search'}
                            isSubmit={true}
                            handleSubmit={handleSearch}
                            onClick={handleSearch}
                        />
                    </div>
                </form>
                <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                    <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                        <div className="flex justify-between items-center mb-4">
                            <h1 className="self-start text-lg font-semibold">Submitted Challenge List</h1>
                            <span className="text-sm text-gray-600">
                                Showing {filteredUsers.length} of {totalItems} submissions
                            </span>
                        </div>
                        <ChallengeWiseSubmissionTable data={filteredUsers} isLoading={isLoading} />

                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                            <div className="flex justify-between items-center mt-6 mb-4">
                                <div className="text-sm text-gray-600">
                                    Page {currentPage} of {totalPages}
                                </div>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => loadData(1)}
                                        disabled={currentPage === 1}
                                        className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                                    >
                                        First
                                    </button>
                                    <button
                                        onClick={() => loadData(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                                    >
                                        Previous
                                    </button>
                                    <span className="px-3 py-1 bg-primary text-white rounded">
                                        {currentPage}
                                    </span>
                                    <button
                                        onClick={() => loadData(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                                    >
                                        Next
                                    </button>
                                    <button
                                        onClick={() => loadData(totalPages)}
                                        disabled={currentPage === totalPages}
                                        className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                                    >
                                        Last
                                    </button>
                                </div>
                                <div className="flex items-center gap-2">
                                    <label htmlFor="itemsPerPage" className="text-sm text-gray-600">Items per page:</label>
                                    <select
                                        id="itemsPerPage"
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            const newPageSize = Number(e.target.value);
                                            setItemsPerPage(newPageSize);
                                            setCurrentPage(1);
                                            loadData(1, newPageSize);
                                        }}
                                        className="px-2 py-1 border border-gray-300 rounded"
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
}

export default ChallengeSubmissions;